var map = {
	"./border-bg-sm.png": 1466,
	"./border-bg.png": 1467,
	"./btn-active.png": 1468,
	"./cny-flower-1.webp": 1469,
	"./cny-flower-2.webp": 1470,
	"./cny-mobile-bg.webp": 1471,
	"./content-deco-1.webp": 1472,
	"./content-deco-2.webp": 1473,
	"./content-deco-3.webp": 1474,
	"./content-deco-4.webp": 1475,
	"./content-deco-5.webp": 1476,
	"./deposit-icon.webp": 1477,
	"./home-icon-active.webp": 1478,
	"./home-icon.webp": 1479,
	"./live-icon-active.webp": 1480,
	"./live-icon.webp": 1481,
	"./master-bg.png": 1482,
	"./me-icon-active.webp": 1483,
	"./me-icon.webp": 1484,
	"./platform.webp": 1485,
	"./product-overview-bg.webp": 1486,
	"./promos-icon-active.webp": 1487,
	"./promos-icon.webp": 1488,
	"./sponsor-icon-active.webp": 1489,
	"./sponsor-icon.webp": 1490,
	"./title-deco-bg.webp": 1491,
	"./title-deco-left.webp": 1492,
	"./title-deco-right.webp": 1493,
	"./vip-icon-active.webp": 1494,
	"./vip-icon.webp": 1495,
	"./withdraw-icon.webp": 1496,
	"./wwr-bg.webp": 1497,
	"./wwr-img.webp": 1498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;